
import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Brain, Target } from "lucide-react";

const EmptyResultState = () => {
  return (
    <Card className="h-fit">
      <CardHeader>
        <CardTitle className="flex items-center">
          <Brain className="mr-2 h-5 w-5 text-blue-500" />
          Verbeterde AI Resultaat
        </CardTitle>
        <CardDescription>
          Start een analyse om exacte product matches te zien
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="text-center py-8 text-muted-foreground">
          <Target className="mx-auto h-12 w-12 mb-4 opacity-50" />
          <p>Geen analyse beschikbaar</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default EmptyResultState;
